import { useMutation } from "@tanstack/react-query";
import { DataOrParams, POST } from "../services/requests";
import { ENDPOINTS } from "../constants/endpoints";

export type SubscribeToNewsletterPayload = {
  fullName: string;
  email: string;
  consent: boolean;
};

export const useSubscribeToNewsletter = () => {
  const mutation = useMutation({
    mutationFn: async (payload: SubscribeToNewsletterPayload) => {
      const data = await POST<DataOrParams>(
        ENDPOINTS.subscribeToNewsletter,
        payload
      );
      return data;
    },
  });

  return { ...mutation };
};
